// ignore-string-externalization

import React from 'react';
import { GetStaticProps, InferGetStaticPropsType } from 'next';
import { Videos } from '../../features/Videos';
import {
  fetchVideosData,
  VideosDataProvider,
} from '../../features/Videos/useVideosData';
import { getLanguage } from '../../utils/getLanguage';

export const getStaticProps: GetStaticProps = async ctx => {
  const smartlingLanguage = getLanguage(ctx.locale!) || 'en-US';

  const data = await fetchVideosData({ smartlingLanguage });

  return {
    props: JSON.parse(JSON.stringify({ videosData: data })),
    revalidate: 60,
  };
};

const VideosPage = ({
  videosData,
}: InferGetStaticPropsType<typeof getStaticProps>) => (
  <VideosDataProvider data={videosData}>
    <Videos />
  </VideosDataProvider>
);

export default VideosPage;
